var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "wa-page",
    {
      attrs: {
        "is-showing-bandana": false,
        "is-showing-sitewide-modal": false,
      },
    },
    [
      _c("wa-page-header", {
        key: "header",
        attrs: { slot: "header" },
        slot: "header",
      }),
      _vm._v(" "),
      _c(
        "main",
        {
          staticClass: "app-content",
          attrs: { slot: "content", role: "main" },
          slot: "content",
        },
        [
          _c("hero", {
            attrs: {
              "last-updated": _vm.lastUpdated,
              "last-updated-formatted": _vm.lastUpdatedFormatted,
            },
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "container padding-y-7xl" },
            [
              _c(
                "div",
                { staticClass: "row roomy align-stretch margin-bottom-4xl" },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "column-12 margin-bottom-2xl laptop:column-8 laptop:margin-bottom-0",
                    },
                    [_c("licenses"), _vm._v(" "), _c("attribution")],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "column-12 laptop:column-4" },
                    [_c("dos"), _vm._v(" "), _c("donts")],
                    1
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "margin-bottom-2xl" },
                [_c("see-pro-license")],
                1
              ),
              _vm._v(" "),
              _c("license-sock", { attrs: { slot: "sock" }, slot: "sock" }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("wa-page-footer", { attrs: { slot: "footer" }, slot: "footer" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }